import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AffiliateService} from '../affiliate.service';
import {ConstantsService} from '../constants.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { AsyncPipe, DecimalPipe } from '@angular/common';
import {Observable} from 'rxjs';


@Component({
    selector: 'app-promotion-notification',
    templateUrl: './promotion-notification.component.html',
    styleUrls: ['./promotion-notification.component.scss'],
    imports: [NgbAlert, AsyncPipe, DecimalPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromotionNotificationComponent implements OnInit {

    hostname$: Observable<string>;
    closed = false;

    constructor(public affiliate: AffiliateService,
                private constants: ConstantsService) {
    }

    ngOnInit() {
      this.hostname$ = this.constants.host$;
    }
}

